import { ColorScheme } from '@design/design-tokens/themes/theme-names';
import DarkLogo from '@static/images/brand/logo-dark.svg';
import LightLogo from '@static/images/brand/logo-light.svg';
import { useThemeStore } from '@terminal/components/theme-controller/stores/useThemeStore';
import { SVGProps } from 'react';

type ToggleBrandLogoProps = SVGProps<SVGSVGElement> & {
  alt?: string;
  title?: string;
};

export const ToggleBrandLogo = (props: ToggleBrandLogoProps) => {
  const isDark = useThemeStore(state => state.colorScheme === ColorScheme.Dark);
  const ThemedLogo = isDark ? DarkLogo : LightLogo;

  return <ThemedLogo {...props} />;
};
